<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
  <sc-title>{{'step title' | translate: ['tmc.transport-attach-detach.dialog.step.title.attach-truck',
    translationService.language]}}</sc-title>
  <sc-flex-fitting-content [vertical]="true">
    <sc-tmc-table [tableModel]="tableModel" #tmcTableComponent [hideFilter]="true"
      (selectionChanged)="onSelectionChanged($event)">
    </sc-tmc-table>
  </sc-flex-fitting-content>
  <div [formGroup]="detailsFormGroup" *ngIf="serviceVehiclesEnabled">
    <sc-flex [centered]="true">
      <mat-checkbox name="useAsServiceTruck" formControlName="useAsServiceTruck">
        {{'use as service truck' | translate:
        ['tmc.transport-attach-detach.dialog.attach-truck.use-as-service-truck',
        translationService.language]}}
      </mat-checkbox>
    </sc-flex>
  </div>
</sc-flex>